import { v4 as uuid } from 'uuid';
import { Env } from '@Constants/BuildInfo';

const structureEditorHostUrlMatch = Env.StructureEditorsHostUrl && Env.StructureEditorsHostUrl.match(/^https?:\/\/[^/]+/gi);
export const targetOrigin = structureEditorHostUrlMatch ? structureEditorHostUrlMatch[0] : window.location.origin;

export const POST_MESSAGE_TYPES = {
  customInit: 'MarvinJS.customInit',
  exportStructure: 'MarvinJS.exportStructure',
  importStructure: 'MarvinJS.importStructure',
  pasteStructure: 'MarvinJS.pasteStructure',
  isEmpty: 'MarvinJS.isEmpty',
  clear: 'MarvinJS.clear',
  on: {
    molchange: 'MarvinJS.on.molchange',
  },
};

export class MarvinInstancePostMessageWrapper {
  static checkOrigin = (origin) => {
    try {
      const url = new URL(origin);
      return url.origin === targetOrigin;
    } catch {
      Logger.warn('Invalid origin URL provided to checkOrigin');
      return false;
    }
  };

  contentWindow = null;

  constructor(contentWindow) {
    this.contentWindow = contentWindow;
  }

  sendPostMessage = (type, payload) => {
    this.contentWindow.postMessage({ type, payload }, targetOrigin);
  };

  sendPostMessagePromise = async (type, payload) => {
    const id = uuid();

    this.contentWindow.postMessage({ type, id, payload }, targetOrigin);

    return new Promise((resolve, reject) => {
      const handler = (event) => {
        if (!this.constructor.checkOrigin(event.origin)) {
          Logger.warn('Untrusted origin:', event.origin);
          return;
        }

        try {
          const { type: eventType, payload: eventPayload, id: eventId } = event.data;
          if (eventType !== type || id !== eventId) return;
          resolve(eventPayload);
          window.removeEventListener('message', handler);
        } catch (e) {
          Logger.error('MarvinInstancePostMessageWrapper.sendPostMessagePromise error: ', e);
          reject(e);
        }
      };
      window.addEventListener('message', handler, false);
    });
  };

  sendPostMessageCallback = (type, payload, callback) => {
    this.contentWindow.postMessage({ type, payload }, targetOrigin);

    const handler = (event) => {
      if (!this.constructor.checkOrigin(event.origin)) {
        Logger.warn('Untrusted origin:', event.origin);
        return;
      }
      try {
        const { type: eventType, payload: eventPayload } = event.data;
        if (eventType !== type) return;
        callback(eventPayload);
      } catch (e) {
        Logger.error('MarvinInstancePostMessageWrapper.sendPostMessageCallback error: ', e);
      }
    };

    window.addEventListener('message', handler, false);
    return () => {
      window.removeEventListener('message', handler);
    };
  };
}
